import { Page } from '../../../components/pdf-export/Page/Page.js';
import { Document as PDFDocument } from '../../../summary/Document.js';
import { Tkv2MarketConditionsExportDeps } from '../../marketConditions/types.js';
import { AdjustmentBreakdownAdditionalStructure } from '../AdjustmentBreakdown/AdjustmentBreakdownAdditionalStructure.js';
import { AdjustmentBreakdownBasement } from '../AdjustmentBreakdown/AdjustmentBreakdownBasement.js';
import { AdjustmentBreakdownBelowGrade } from '../AdjustmentBreakdown/AdjustmentBreakdownBelowGrade.js';
import { AdjustmentBreakdownCondition } from '../AdjustmentBreakdown/AdjustmentBreakdownCondition.js';
import { AdjustmentBreakdownGla } from '../AdjustmentBreakdown/AdjustmentBreakdownGla/AdjustmentBreakdownGla.js';
import { AdjustmentBreakdownImprovementValue } from '../AdjustmentBreakdown/AdjustmentBreakdownImprovementValue.js';
import { AdjustmentBreakdownManualCost } from '../AdjustmentBreakdown/AdjustmentBreakdownManualCost.js';
import { AdjustmentBreakdownParking } from '../AdjustmentBreakdown/AdjustmentBreakdownParking.js';
import { AdjustmentBreakdownPatioDeck } from '../AdjustmentBreakdown/AdjustmentBreakdownPatioDeck.js';
import { AdjustmentBreakdownQuality } from '../AdjustmentBreakdown/AdjustmentBreakdownQuality.js';
import { AdjustmentBreakdownSiteValue } from '../AdjustmentBreakdown/AdjustmentBreakdownSiteValue.js';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.js';
import { MarketConditionsAdjustmentExport } from './MarketConditionsAdjustmentExport.js';

export const SummaryExport = (
  props: Tkv2PairedCostSummaryInterfaceV2 & {
    marketConditionsExportDeps: Tkv2MarketConditionsExportDeps;
    marketTrendsPngSource?: string;
  },
) => {
  return (
    <PDFDocument>
      <Page title="Adjustment Breakdown">
        {!props.exportableCommentaries.market.omitFromExport && (
          <MarketConditionsAdjustmentExport {...props} />
        )}
        {!props.exportableCommentaries.site.omitFromExport && (
          <AdjustmentBreakdownSiteValue {...props} />
        )}
        {!props.exportableCommentaries.allImprovements.omitFromExport && (
          <AdjustmentBreakdownImprovementValue {...props} />
        )}
        {!props.exportableCommentaries.quality.omitFromExport && (
          <AdjustmentBreakdownQuality {...props} />
        )}
        {!props.exportableCommentaries.condition.omitFromExport && (
          <AdjustmentBreakdownCondition {...props} />
        )}
        {!props.exportableCommentaries.mainDwelling.omitFromExport && (
          <AdjustmentBreakdownGla {...props} />
        )}
        {!props.exportableCommentaries.basement.omitFromExport && (
          <AdjustmentBreakdownBasement {...props} />
        )}
        {!props.exportableCommentaries.garageCarport.omitFromExport && (
          <AdjustmentBreakdownParking {...props} />
        )}
        {!props.exportableCommentaries.porchPatioDeck.omitFromExport && (
          <AdjustmentBreakdownPatioDeck {...props} />
        )}
        {!props.exportableCommentaries.attic.omitFromExport && (
          <AdjustmentBreakdownAdditionalStructure
            id="isAtticCommentaryInExport"
            title="Attic"
            breakdownCategory="attic"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.belowGradeANSI.omitFromExport && (
          <AdjustmentBreakdownBelowGrade
            id="isBelowGradeCommentaryInExport"
            title="Below Grade (per ANSI)"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.barn.omitFromExport && (
          <AdjustmentBreakdownAdditionalStructure
            id="isBarnCommentaryInExport"
            title="Barn"
            breakdownCategory="barn"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.bonusRoom.omitFromExport && (
          <AdjustmentBreakdownAdditionalStructure
            id="isBonusRoomCommentaryInExport"
            title="Bonus Room"
            breakdownCategory="bonusRoom"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.adu.omitFromExport && (
          <AdjustmentBreakdownAdditionalStructure
            id="isGuestHouseCommentaryInExport"
            title="Guest House"
            breakdownCategory="adu"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.manufactured.omitFromExport && (
          <AdjustmentBreakdownAdditionalStructure
            id="isManufacturedDwellingCommentaryInExport"
            title="Manufactured Dwelling"
            breakdownCategory="manufactured"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.pool.omitFromExport && (
          <AdjustmentBreakdownAdditionalStructure
            id="isPoolCommentaryInExport"
            title="Pool"
            breakdownCategory="pool"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.shed.omitFromExport && (
          <AdjustmentBreakdownAdditionalStructure
            id="isShedCommentaryInExport"
            title="Shed"
            breakdownCategory="shed"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.workshop.omitFromExport && (
          <AdjustmentBreakdownAdditionalStructure
            id="isWorkshopCommentaryInExport"
            title="Workshop"
            breakdownCategory="workshop"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
        {!props.exportableCommentaries.manual.omitFromExport && (
          <AdjustmentBreakdownManualCost
            id="isManualCostInExport"
            summary={props}
            compSequence={props.compSequence}
          />
        )}
      </Page>
    </PDFDocument>
  );
};
